import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import {
    accordion,
    button,
    checkbox,
    dataTable,
    datePicker,
    dynamicDropdown,
    formField,
    header,
    link,
    menu,
    overflowMenu,
    pagination,
    radio,
    select,
    tag,
    textField,
    tooltip,
    typography,
} from "@waytek/Utilities/styleguide";
import { btFocus, colorPalette } from "@waytek/Utilities/variables";

const setPreStyles = () => {
    // Add some post styleguide customizations. These cannot be overridden by the style guid.
    setPreStyleGuideTheme({
        accordion,
        button,
        checkbox,
        colors: colorPalette,
        datePicker,
        dataTable,
        dynamicDropdown,
        focus: btFocus,
        formField,
        header,
        link,
        menu,
        overflowMenu,
        pagination,
        radio,
        select,
        tag,
        textField,
        tooltip,
        typography,
        zIndex: {
            popover: 9999,
            modal: 9999,
            stickyFooter: 1290,
            menu: 1288,
        },
    });
};

export default setPreStyles;
